<template>
  <div class="wzbleft">
    <div class="left-title">支部简介</div>
    <div class="box dangyuan">
      <div class="iconfont icon-dangyuan"></div>
      <div>
        成员数：
        <span class="dy_number">{{info.totalNumber}}</span>
        <span class="dy_unit">人</span>
      </div>
    </div>

    <y-scroll
      :contentArr="leftScroll"
      :height="300"
      :width="width * 0.25"
      :lineNum="1"
      :time="5000"
    >
      <div slot="scroll" slot-scope="props" class="scroll-wrapper">
        <p v-if="props.todo.text" class="wsq-jianjie">{{props.todo.text}}</p>
        <img v-else-if="props.todo.img" class="scroll-pic" :src="props.todo.img" />
      </div>
    </y-scroll>

    <img class="wzb-ma" v-if="info.qrcodeUrl" :src="info.qrcodeUrl" />
  </div>
</template>

<script>
import yScroll from "../../../components/yScroll";
export default {
  components: {
    yScroll
  },
  data() {
    return {};
  },
  props: {
    height: Number,
    width: Number,
    info: {
      type: Object,
      default: () => {}
    },
    leftScroll: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="less" scoped>
.wzbleft {
  height: 100%;
  position: relative;
}
.left-title {
  text-align: center;
  font-size: 0.28rem;
  font-weight: 600;
  color: #4c4c4c;
}
.dangyuan {
  color: #ff4500;
  justify-content: center;
  font-size: 0.24rem;
  & > .icon-dangyuan {
    font-size: 0.3rem;
    padding: 0.09rem 0.05rem 0 0;
  }
}
.dy_number {
  font-size: 0.35rem;
}
.dy_unit {
  font-size: 0.16rem;
}
.wzb-jianjie {
  letter-space: 1px;
  color: #333;
  line-height: 1.8;
}
.wzb-ma {
  display: block;
  width: 2rem;
  height: 2rem;
  margin: 30px auto;
}
.scroll-wrapper {
  padding: 0 15px;
}
.wsq-jianjie {
  letter-space: 1px;
  color: #333;
  line-height: 2;
  padding: 0 8.88%;
  font-size: 0.25rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
}
.scroll-pic {
  padding-top: 1px;
  width: 100%;
  height: auto;
}
</style>
